// Libraries
import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { axisClasses } from "@mui/x-charts";
import { Box } from "@mui/material";
import { Col, Row } from "react-bootstrap";

// Constants

// Styles
import "./Dashboard.scss";

const Dashboard = (props) => {
  const { dashboardStats, gpuStatistic } = props;
  const chartSetting = {
    yAxis: [
      {
        label: "",
      },
    ],
    height: 300,
    sx: {
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: "rotate(-90deg) translate(0px, -20px)",
      },
      [`.${axisClasses.bottom} .${axisClasses.tickLabel}`]: {
        transform: "rotateZ(0deg)",
      },
    },
  };

  const queriesDataSet = dashboardStats?.queries?.reduce((acc, qu) => {
    for (const [key, value] of Object.entries(qu)) {
      acc.push({
        date: key
          .replaceAll("-", "/")
          .split("/")
          .reverse()
          .slice(0, 2)
          .join("/"),
        value: value,
      });
    }
    return acc;
  }, []);

  const tokensDataSet = dashboardStats?.tokens?.reduce((acc, qu) => {
    for (const [key, value] of Object.entries(qu)) {
      acc.push({
        date: key
          .replaceAll("-", "/")
          .split("/")
          .reverse()
          .slice(0, 2)
          .join("/"),
        value: value,
      });
    }
    return acc;
  }, []);
  const costDataSet = dashboardStats?.costs?.reduce((acc, qu) => {
    for (const [key, value] of Object.entries(qu)) {
      acc.push({
        date: key
          .replaceAll("-", "/")
          .split("/")
          .reverse()
          .slice(0, 2)
          .join("/"),
        value: value,
      });
    }
    return acc;
  }, []);

  const renderGraph = (label, dataSet, colors) => {
    return (
      <BarChart
        dataset={dataSet}
        xAxis={[{ scaleType: "band", dataKey: "date" }]}
        series={[{ dataKey: "value", label: label }]}
        colors={colors}
        {...chartSetting}
      />
    );
  };

  const renderToken = (statDetails, label, dataSet, colors) => {
    return (
      <Col md={4} className="d-flex flex-column">
        <div className="token-details h-50 mt-5">
          <div className="d-flex justify-content-center w-100 full-border">
            {statDetails.header}
          </div>
          <div className="d-flex flex-row w-100">
            <div className="d-flex flex-column w-50">
              <div className="full-border d-flex justify-content-center px-3">
                {statDetails.title1}
              </div>
              <div className="full-border d-flex justify-content-center px-0">
                {gpuStatistic[statDetails.value1] % 1 === 0
                  ? gpuStatistic[statDetails.value1]
                  : gpuStatistic[statDetails.value1].toFixed(2)}
              </div>
            </div>
            <div className="d-flex flex-column w-50">
              <div className="full-border d-flex justify-content-center px-3">
                {statDetails.title2}
              </div>
              <div className="full-border d-flex justify-content-center">
                {gpuStatistic[statDetails.value2] % 1 === 0
                  ? gpuStatistic[statDetails.value2]
                  : gpuStatistic[statDetails.value2].toFixed(2)}
              </div>
            </div>
          </div>
        </div>
        <div>
          <Box sx={{ width: "100%", display: "flex" }}>
            {renderGraph(label, dataSet, colors)}
          </Box>
        </div>
      </Col>
    );
  };

  return (
    <div className="dashboard-container">
      {gpuStatistic && dashboardStats ? (
        <Row className="w-100 h-100">
          {renderToken(
            {
              header: "Token Count",
              title1: "Question",
              title2: "Answer",
              value1: "avg_que_token",
              value2: "avg_ans_token",
            },
            "Queries per day",
            queriesDataSet,
            ["#4e5871"]
          )}
          {renderToken(
            {
              header: "Max Token",
              title1: "Question",
              title2: "Answer",
              value1: "max_que_token",
              value2: "max_ans_token",
            },
            "Tokens per day",
            tokensDataSet,
            ["#a2c7e4"]
          )}
          {renderToken(
            {
              header: "Response",
              title1: "Average",
              title2: "Max",
              value1: "avg_response_time",
              value2: "max_response_time",
            },
            "Cost per day(in cents)",
            costDataSet,
            ["#01763f"]
          )}
        </Row>
      ) : (
        <div className="d-flex justify-content-center w-100">
          <span>No data</span>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
